<template>
    <div class="apprentice-simple-card remove-bottom-card-margin sources">
        <div class="source-header">
            <h4 class="title">{{ $t('source.source_list') }} ({{ list.length }})</h4>
        </div>

        <design-2021-apprentice-data-table
            class="source-table"
            :fields="fields"
            :items="sortedItems">
            <template v-slot:options>
                <div class="header-actions">
                    <b-dropdown
                        class="ellipsis-nav bordered-menu source-list-sorting-nav"
                        variant="primary"
                        toggle-class="text-decoration-none"
                        right
                        text="Right align"
                        no-caret>
                        <template #button-content>
                            <i class="fas fa-sort-alpha-up"></i>
                        </template>
                        <b-dropdown-group
                            id="source-list-sorting"
                            :header="$t('source.filter_on')">
                            <b-dropdown-divider></b-dropdown-divider>
                            <b-dropdown-item
                                :active="sortedBy === 'title'"
                                @click.prevent.stop="setSortedBy('title')">
                                {{ $t('common.title') }}
                            </b-dropdown-item>
                            <b-dropdown-item
                                :active="sortedBy === 'author'"
                                @click.prevent.stop="setSortedBy('author')">
                                {{ $t('source.filter_on') }}
                            </b-dropdown-item>
                            <b-dropdown-item
                                :active="sortedBy === 'source-type'"
                                @click.prevent.stop="setSortedBy('source-type')">
                                {{ $t('source.source_list') }}
                            </b-dropdown-item>
                        </b-dropdown-group>
                    </b-dropdown>

                    <b-dropdown
                        class="ellipsis-nav bordered-menu source-list-nav"
                        variant="primary"
                        right
                        text="Right align"
                        no-caret
                        toggle-class="source-list-context-menu">
                        <template #button-content>
                            <i class="fas fa-fw fa-ellipsis-v"></i>
                        </template>
                        <b-dropdown-item
                            class="edit-group"
                            @click="downloadSource">
                            <i class="btn-download"></i>{{ $t('source.download_source_list') }}
                        </b-dropdown-item>
                        <b-dropdown-item
                            class="lock-group"
                            @click.prevent.stop="clearList">
                            <i class="btn-remove"></i>{{ $t('source.delete_source_list') }}
                        </b-dropdown-item>
                    </b-dropdown>
                </div>
            </template>

            <template v-slot:cell(description)="data">
                <design-2021-apprentice-display-html-component
                    class="source-description"
                    :html-content="getDescription(data.item)">
                </design-2021-apprentice-display-html-component>
            </template>

            <template v-slot:cell(created_by)="data">
                <div class="made-by">
                    {{ data.item.user.full_name }}
                </div>
            </template>

            <template v-slot:cell(type)="data">
                <div class="source-type">
                    {{ data.item.type.description }}
                </div>
            </template>

            <template v-slot:cell(actions)="data">
                <div class="source-actions">
                    <b-button
                        class="btn-open btn-show-source remove-icon-margin"
                        variant="primary-icon-only"
                        @click="showItemSwal(data.item.id)"
                        :v-b-tooltip="$t('source.example_source_reference')">
                    </b-button>
                    <b-button
                        class="btn-edit btn-edit-source remove-icon-margin"
                        variant="primary-icon-only"
                        @click="editItem(data.item.id)"
                        :v-b-tooltip="$t('source.edit_source_list_reference')">
                    </b-button>
                    <b-button
                        class="btn-remove btn-remove-source remove-icon-margin"
                        v-b-tooltip="$t('source.delete_source_reference')"
                        variant="danger-icon-only"
                        @click="removeItemSwall(data.item.id)">
                    </b-button>
                </div>
            </template>
        </design-2021-apprentice-data-table>

        <b-modal
            v-model="modal_item_show"
            hide-footer
            :title="$t('source.example_references_in_text')"
            modal-class="apprentice-default-modal">
            <b-row>
                <b-col lg="12">
                    <p id="example">
                        <design-2021-apprentice-display-html-component
                            :html-content="example_text"></design-2021-apprentice-display-html-component>
                    </p>

                    <br />
                </b-col>
            </b-row>
        </b-modal>
    </div>
</template>

<script>
import { SourceBus } from '../../app';
import $ from 'jquery';

export default {
    name: 'design-2021-source-list-table-component',
    props: ['projectId', 'sourceListDataIn'],
    data() {
        return {
            list: [],
            modal_item_show: false,
            modal_item_tekst: '',
            copy_text: 'copy',
            example_text: '',
            fields: [
                {
                    key: 'description',
                    label: this.$t('source.source_reference'),
                },
                {
                    key: 'type',
                    label: this.$t('source.source_type'),
                },
                {
                    key: 'created_by',
                    label: this.$t('source.created_by'),
                },
                {
                    key: 'actions',
                    label: this.$t('common.actions'),
                },
            ],
            sortedBy: localStorage.getItem('sortedBy') ? localStorage.getItem('sortedBy') : 'title',
        };
    },

    methods: {
        downloadList(evt) {
            let uri = '/source/fetchWordList/' + this.projectId;

            axios
                .get(uri)
                .then((response) => {})
                .catch((error) => {
                    // error callback
                })
                .then(() => {
                    // always run
                });
        },

        showItemSwal(id) {
            this.modal_item_show = true;
            this.fetchExampleText(id);
        },

        editItem(id) {
            let uri = 'source/getSource/' + id;

            axios
                .get(uri)
                .then((response) => {
                    let source_type = response.data.data.source_type;
                    let data = response.data.data;

                    if (source_type) {
                        if (source_type == 1) {
                            this.$emit('show-tab', 1);
                            SourceBus.$emit('editBookSource', data);
                        }

                        if (source_type == 2) {
                            this.$emit('show-tab', 0);
                            SourceBus.$emit('editInternetSource', data);
                        }

                        if (source_type == 3) {
                            this.$emit('show-tab', 2);
                            SourceBus.$emit('editJournalSource', data);
                        }

                        if (source_type == 4) {
                            this.$emit('show-tab', 3);
                            SourceBus.$emit('editPaperSource', data);
                        }

                        if (source_type == 5) {
                            this.$emit('show-tab', 4);
                            SourceBus.$emit('editRapportSource', data);
                        }

                        $('.main-content').animate({ scrollTop: 0 }, 500);
                    }
                })
                .catch((error) => {
                    // error callback
                })
                .then(() => {
                    // always run
                });
        },

        removeItem(id) {
            let uri = 'source/delete/' + id;

            axios
                .delete(uri)
                .then((response) => {
                    this.alert.success(this.$t('source.source_is_deleted_successfully'));
                    this.list = this.list.filter((item) => {
                        return item.id !== id;
                    });
                    SourceBus.$emit('remove-from-source-counter');
                })
                .catch((error) => {
                    // error callback
                })
                .then(() => {
                    // always run
                });
        },

        removeItemSwall(id) {
            this.alert
                .confirm(this.$t('source.delete_source'), this.$t('source.are_you_sure_you_want_to_delete_this_source'))
                .then((confirm) => {
                    if (confirm) {
                        this.removeItem(id);
                    }
                });
        },

        clearList() {
            this.alert
                .confirm(
                    this.$t('source.delete_source_list'),
                    this.$t('source.are_you_sure_you_want_to_delete_this_source_list'),
                    this.$t('common.yes_delete'),
                )
                .then((confirm) => {
                    if (confirm) {
                        this.list = '';
                        this.deleteList();
                    }
                });
        },

        deleteList() {
            let uri = 'source/deleteAll/' + this.projectId;

            axios
                .post(uri, '')
                .then((response) => {
                    if (response.data) {
                        this.onReset(evt);
                        this.alert.success(this.$t('source.source_is_deleted_successfully'));
                    }
                })
                .catch((error) => {
                    if (error.response.status == 422) {
                        this.errors = error.response.data.errors;
                    }
                });
        },

        fetchSourceList(data) {
            if (this.list.map((source) => source.id).indexOf(data.id) !== -1) {
                for (const [index, source] of this.list.entries()) {
                    if (source.id === data.id) {
                        this.list.splice(index, 1, data);
                        break;
                    }
                }
            } else {
                this.list.push(data);
                SourceBus.$emit('add-to-source-counter');
            }
        },

        fetchExampleText(id) {
            this.example_text = '';
            let uri = '/source/fetch/example/' + id;

            axios
                .get(uri)
                .then((response) => {
                    let data = response.data.data;

                    if (data) {
                        this.example_text = data.total;
                    }
                })
                .catch((error) => {
                    // error callback
                })
                .then(() => {
                    // always run
                });
        },

        downloadSource() {
            window.open(`/source/fetchWordList/${this.projectId}`, '_blank');
        },

        setSortedBy(label) {
            this.sortedBy = label;
            localStorage.setItem('sortedBy', label);
        },

        getDescription(source) {
            switch (source.type.id) {
                case 1: // Book Source
                    return `<span class="author">${source.description_raw.author}</span><span class="publish_year">${source.description_raw.publish_year}</span><span class="title">${source.description_raw.title}</span><span class="edition">${source.description_raw.edition}</span><span class="publisher">${source.description_raw.publisher}</span>`;

                case 2: // Internet Source
                    if (source.description_raw.author !== '') {
                        return `<span class="author">${source.description_raw.author}</span><span class="publication">${source.description_raw.publication}</span><span class="title">${source.description_raw.title}</span><span class="consult_date">${source.description_raw.consult_date}</span><span class="url">${source.description_raw.url}</span>`;
                    }

                    return `<span class="title">${source.description_raw.title}</span><span class="publication">${source.description_raw.publication}</span><span class="consult_date">${source.description_raw.consult_date}</span><span class="url">${source.description_raw.url}</span>`;

                case 3: // Journal Source
                    return `<span class="author">${source.description_raw.author}</span><span class="publish_year">${source.description_raw.publish_year}</span><span class="title">${source.description_raw.title}</span> <span class="vol_is">${source.description_raw.vol_is}</span><span class="pages">${source.description_raw.pages}</span><span class="url">${source.description_raw.url}</span>`;

                case 4: // Paper Source
                    return `<span class="author">${source.description_raw.author}</span><span class="publication_date">${source.description_raw.publication_date}</span><span class="title">${source.description_raw.artikel_title}</span><span class="paper_title">${source.description_raw.paper_title}</span><span class="result">${source.description_raw.result}</span><span class="pages">${source.description_raw.pages}</span><span class="url">${source.description_raw.url}</span>`;

                case 5: // Rapport Source
                    return `<span class="author">${source.description_raw.author}</span><span class="publication_year">${source.description_raw.publication_year}</span><span class="title">${source.description_raw.title}</span><span class="addtion">${source.description_raw.addtion}</span><span class="url">${source.description_raw.url}</span>`;
            }
        },
    },

    created() {
        SourceBus.$on('pushData', (data) => {
            this.fetchSourceList(data);
        });
    },

    watch: {
        sourceListDataIn: {
            handler(value) {
                this.list = value.data;
            },
            deep: true,
        },

        list: function (val) {
            this.list = val;
        },
    },

    computed: {
        sortedItems() {
            if (this.list.length === 0) {
                return [];
            }

            switch (this.sortedBy) {
                case 'title':
                    return this.list.sort(function (first, second) {
                        const firstDescription = first.title ? first.title.toLowerCase() : '';
                        const secondDescription = second.title ? second.title.toLowerCase() : '';

                        return firstDescription < secondDescription ? -1 : firstDescription > secondDescription ? 1 : 0;
                    });

                case 'author':
                    let sources = this.list.map((source) => {
                        if (source.authors.length > 0) {
                            let names = [];
                            if (source.authors.length === 0) {
                                source.authors = null;
                            }

                            for (const author of source.authors) {
                                let name = '';
                                if (author.last_name && author.initials) {
                                    name = `${author.last_name} ${author.initials}`;
                                } else if (author.last_name) {
                                    name = author.last_name;
                                }
                                names.push(name);
                            }

                            source.authors_list_name = names.join(', ');
                        } else {
                            source.authors = ' ';
                        }

                        return source;
                    });

                    return sources.sort(function (first, second) {
                        const firstAuthors = first.authors_list_name ? first.authors_list_name.toLowerCase() : '';
                        const secondAuthors = second.authors_list_name ? second.authors_list_name.toLowerCase() : '';

                        return firstAuthors < secondAuthors ? -1 : firstAuthors > secondAuthors ? 1 : 0;
                    });

                case 'source-type':
                    return this.list.sort(function (first, second) {
                        const firstType = first.type.description.toLowerCase();
                        const secondType = second.type.description.toLowerCase();

                        return firstType < secondType ? -1 : firstType > secondType ? 1 : 0;
                    });
            }
        },
    },
};
</script>

<style scoped lang="scss">
.sources ::v-deep {
    margin-top: map-get($grid-gutter-spacing, 'twenty-one') * 2;

    .source-header {
        margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
    }

    .apprentice-simple-card {
        padding: 0;
        margin-bottom: 0;
        border-radius: 0;
        background-color: transparent;
        height: auto;
    }
}

.header-actions {
    display: flex;
    flex-direction: row;
    flex: 1;
    align-items: center;
    justify-content: flex-end;

    .btn {
        &:not(:last-child) {
            margin-right: 0;
            margin-bottom: map-get($grid-gutter-spacing, 'eight');
        }

        &:before {
            margin-right: 0;
        }
    }

    .btn-filter-sourcelist {
        font-size: $base-font-size;
        line-height: 1.5;
        align-self: flex-start;
    }
}

.source-actions {
    display: flex;
    align-items: center;

    .btn {
        &:not(:last-child) {
            margin-right: map-get($grid-gutter-spacing, 'fifteen');
        }
    }
}

.source-list-nav ::v-deep,
.source-list-sorting-nav ::v-deep,
.source-list-nav.show ::v-deep,
.source-list-sorting-nav.show ::v-deep {
    button.dropdown-toggle {
        &,
        &:active,
        &:focus,
        &:not(:disabled):not(.disabled):active {
            background-color: $primary;
            color: $white !important;
        }
    }
}

.source-list-sorting-nav ::v-deep {
    .dropdown-header {
        padding: map-get($grid-gutter-spacing, 'ten') map-get($grid-gutter-spacing, 'fifteen') 2px
            map-get($grid-gutter-spacing, 'fifteen');
        font-weight: $font-weight-medium;
        font-size: $base-font-size;
    }

    button.dropdown-toggle {
        font-size: $base-font-size;
        line-height: 1.5;
        align-self: flex-start;
        margin-right: map-get($grid-gutter-spacing, 'fifteen');

        i {
            text-align: center;
            width: 1.25em;
        }
    }

    .dropdown-menu {
        padding: 0;

        > li {
            padding: 0;

            &:hover {
                background-color: transparent;
            }
        }

        li {
            padding: 0;

            .dropdown-item {
                padding: map-get($grid-gutter-spacing, 'ten') map-get($grid-gutter-spacing, 'fifteen');

                &.active:hover,
                &:hover {
                    background-color: $primary;
                    color: $white;
                }
            }
        }
    }
}

.source-list-nav ::v-deep {
    .dropdown-menu {
        li {
            .btn-download {
                color: $primary;
            }
        }
    }
}

.source-table ::v-deep {
    .source-description {
        .title {
            font-style: italic;
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'sm')) {
    .header-actions {
        flex: 0 0 auto;
        justify-content: flex-end;
    }

    .source-table ::v-deep {
        .apprentice-table-header {
            flex-direction: row;
        }

        .apprentice-table-filters,
        .apprentice-data-table-actions {
            justify-content: flex-end;
            flex: 1 0 auto;
        }

        .apprentice-table-filters {
            margin-bottom: 0;
            justify-content: flex-start;
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'md')) {
    .header-actions {
        .btn {
            &:not(:last-child) {
                margin-right: map-get($grid-gutter-spacing, 'fifteen');
                margin-bottom: 0;
            }
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'xl')) {
    .header-actions {
        flex: initial;
    }
}
</style>
